var positionTooltipX = function positionTooltipX(tooltip) {
  if (typeof window !== "undefined" && (tooltip === null || tooltip === void 0 ? void 0 : tooltip.offsetParent)) {
    var content = tooltip.getBoundingClientRect();
    var parent = tooltip.offsetParent.getBoundingClientRect();
    var _window = window,
        innerWidth = _window.innerWidth;
    var offsetPadding = parseInt(getComputedStyle(tooltip).getPropertyValue("--tds-tooltip--offset-padding"));
    var overflowLeft = -(parent.left + parent.width / 2 - content.width / 2 - offsetPadding);
    var overflowRight = -(parent.left + parent.width / 2 + content.width / 2 + offsetPadding - innerWidth);

    if (overflowLeft > 0) {
      tooltip.style.setProperty("--tds-tooltip--x-offset", "".concat(overflowLeft, "px"));
    }

    if (overflowRight < 0) {
      tooltip.style.setProperty("--tds-tooltip--x-offset", "".concat(overflowRight, "px"));
    }
  }
};

var positionTooltipY = function positionTooltipY(tooltip) {
  if (typeof window !== "undefined" && (tooltip === null || tooltip === void 0 ? void 0 : tooltip.offsetParent)) {
    var content = tooltip.getBoundingClientRect();
    var parent = tooltip.offsetParent.getBoundingClientRect();
    var _window2 = window,
        innerHeight = _window2.innerHeight;
    var safeSpace = getComputedStyle(tooltip).getPropertyValue("--tds-tooltip--safe-space");
    var offsetPadding = parseInt(getComputedStyle(tooltip).getPropertyValue("--tds-tooltip--offset-padding"));
    tooltip.style.removeProperty("top");
    tooltip.style.removeProperty("bottom");

    if (parent.bottom + content.height + offsetPadding > innerHeight) {
      tooltip.style.setProperty("top", "auto");
      tooltip.style.setProperty("bottom", "calc(100% + ".concat(safeSpace, ")"));
    }

    if (parent.top - content.height - offsetPadding < 0) {
      tooltip.style.setProperty("top", "calc(100% + ".concat(safeSpace, ")"));
      tooltip.style.setProperty("bottom", "auto");
    }
  }
};

var setTooltipOverlayY = function setTooltipOverlayY(tooltip, orientation, parentModal) {
  if (typeof window !== "undefined" && (tooltip === null || tooltip === void 0 ? void 0 : tooltip.parentNode)) {
    var _tooltip$parentElemen;

    var parent = (_tooltip$parentElemen = tooltip.parentElement) === null || _tooltip$parentElemen === void 0 ? void 0 : _tooltip$parentElemen.getBoundingClientRect();
    var content = tooltip.getBoundingClientRect();
    var dialog = parentModal === null || parentModal === void 0 ? void 0 : parentModal.getBoundingClientRect();
    if (!parent) return;
    var parentY = dialog ? parent.y - dialog.y : parent.y;
    var offsetAlign = parseInt(getComputedStyle(tooltip).getPropertyValue("--tds-tooltip--offset-align"));
    var overflowTop = -(parentY - content.height - offsetAlign);
    var overflowBottom = window.innerHeight - (parentY + parent.height) - content.height + offsetAlign;
    var aboveParentY = parentY - content.height - offsetAlign;
    var belowParentY = parentY + parent.height + offsetAlign;
    var positionTop = orientation === "down" ? overflowBottom < 0 ? aboveParentY : belowParentY : overflowTop > 0 ? belowParentY : aboveParentY;
    tooltip.style.top = "".concat(positionTop, "px");
  }
};

var setTooltipOverlayX = function setTooltipOverlayX(tooltip, align, fullWidth, parentModal) {
  if (typeof window !== "undefined" && (tooltip === null || tooltip === void 0 ? void 0 : tooltip.parentNode)) {
    var _tooltip$parentElemen2;

    var parent = (_tooltip$parentElemen2 = tooltip.parentElement) === null || _tooltip$parentElemen2 === void 0 ? void 0 : _tooltip$parentElemen2.getBoundingClientRect();
    var content = tooltip.getBoundingClientRect();
    var dialog = parentModal === null || parentModal === void 0 ? void 0 : parentModal.getBoundingClientRect();
    if (!parent) return;
    var parentX = dialog ? parent.x - dialog.x : parent.x;

    if (fullWidth) {
      tooltip.style.left = "".concat(parentX, "px");
      tooltip.style.inlineSize = "".concat(parent.width, "px");
      tooltip.style.maxInlineSize = "".concat(parent.width, "px");
    } else {
      var offsetPadding = parseInt(getComputedStyle(tooltip).getPropertyValue("--tds-tooltip--offset-padding"));
      var offsetAlign = parseInt(getComputedStyle(tooltip).getPropertyValue("--tds-tooltip--offset-align"));
      var startX = -content.width / 2 + parent.width / 2 + offsetAlign / 2;
      if (align === "end") startX = -content.width + offsetAlign + parent.width;
      if (align === "start") startX = -offsetAlign;
      var overflowLeft = -(parentX + startX - offsetPadding);
      var overflowRight = window.innerWidth - (parentX + startX) - content.width - offsetPadding;
      var positionX = parentX + startX + Math.min(0, overflowRight) + Math.max(0, overflowLeft);
      tooltip.style.left = "".concat(positionX, "px");
    }
  }
};

var positionTooltipOverlay = function positionTooltipOverlay(tooltip, align, orientation, fullWidth) {
  var parentModal = getBlockFormattingContainer(tooltip.parentElement);
  setTooltipOverlayX(tooltip, align, Boolean(fullWidth), parentModal);
  setTooltipOverlayY(tooltip, orientation, parentModal);
};

var positionTooltip = function positionTooltip(tooltip) {
  positionTooltipX(tooltip);
  positionTooltipY(tooltip);
};

function getTooltipModifiers(tooltip) {
  var overlay = tooltip.classList.contains("tds-tooltip--overlay");
  var fullWidth = tooltip.classList.contains("tds-tooltip--width-full");
  var align = null;
  var orientation = null;

  if (tooltip.classList.contains("tds-tooltip--align-start")) {
    align = "start";
  }

  if (tooltip.classList.contains("tds-tooltip--align-end")) {
    align = "end";
  }

  if (tooltip.classList.contains("tds-tooltip--orientation-down")) {
    orientation = "down";
  }

  return {
    align: align,
    fullWidth: fullWidth,
    orientation: orientation,
    overlay: overlay
  };
}

var getBlockFormattingContainer = function getBlockFormattingContainer(element) {
  var style = element ? getComputedStyle(element) : null;
  var isFixed = style && style.getPropertyValue("position") === "fixed";
  var isOverflowing = style && ["auto", "scroll"].includes(style.getPropertyValue("overflow"));

  if (isFixed && isOverflowing) {
    return element;
  } else {
    return element && getBlockFormattingContainer(element.parentElement);
  }
};

var initTooltip = function initTooltip(tooltip, props) {
  var _tooltip$parentElemen3;

  var closeOnBlur = props.closeOnBlur,
      isClickToOpen = props.isClickToOpen,
      onClose = props.onClose,
      onOpen = props.onOpen;

  var _getTooltipModifiers = getTooltipModifiers(tooltip),
      align = _getTooltipModifiers.align,
      fullWidth = _getTooltipModifiers.fullWidth,
      orientation = _getTooltipModifiers.orientation,
      overlay = _getTooltipModifiers.overlay;

  var opener = (_tooltip$parentElemen3 = tooltip.parentElement) === null || _tooltip$parentElemen3 === void 0 ? void 0 : _tooltip$parentElemen3.querySelector("[data-tds-tooltip-trigger]");
  var scrollTimeout;

  var setTooltipPosition = function setTooltipPosition() {
    if (overlay) {
      positionTooltipOverlay(tooltip, align, orientation, fullWidth);
    } else {
      positionTooltip(tooltip);
    }
  };

  setTooltipPosition();

  var closeTooltipIfOutside = function closeTooltipIfOutside(e) {
    var _tooltip$parentElemen4;

    if (!((_tooltip$parentElemen4 = tooltip.parentElement) === null || _tooltip$parentElemen4 === void 0 ? void 0 : _tooltip$parentElemen4.contains(e.target))) {
      closeTooltip(e);
    }
  };

  var handleWindowKeyDown = function handleWindowKeyDown(e) {
    if (e.key === "Escape" || e.key === "Esc") {
      closeTooltip(e);
    }
  };

  var handleOpenerKeyDown = function handleOpenerKeyDown(e) {
    var key = e.key;

    if (key === " " || key === "Enter" || key === "ArrowDown") {
      e.preventDefault();
      openTooltip(e);
    }
  };

  var openTooltip = function openTooltip(e) {
    tooltip.classList.add("tds-tooltip--open");
    tooltip.classList.remove("tds-tooltip--closed");
    setTooltipPosition();
    clearTimeout(scrollTimeout);
    if (overlay) window.addEventListener("scroll", setTooltipPosition);
    window.addEventListener("resize", setTooltipPosition);
    document.addEventListener("keydown", handleWindowKeyDown);
    document.addEventListener("click", closeTooltipIfOutside);
    opener === null || opener === void 0 ? void 0 : opener.removeEventListener("click", openTooltip);
    opener === null || opener === void 0 ? void 0 : opener.addEventListener("click", closeTooltip);
    if (onOpen) onOpen(e);
  };

  var closeTooltip = function closeTooltip(e) {
    tooltip.classList.remove("tds-tooltip--open");
    tooltip.classList.add("tds-tooltip--closed");

    if (overlay) {
      scrollTimeout = setTimeout(function () {
        return window.removeEventListener("scroll", setTooltipPosition);
      }, 500);
    }

    window.removeEventListener("resize", setTooltipPosition);
    document.removeEventListener("keydown", handleWindowKeyDown);
    document.removeEventListener("click", closeTooltipIfOutside);
    opener === null || opener === void 0 ? void 0 : opener.removeEventListener("click", closeTooltip);
    opener === null || opener === void 0 ? void 0 : opener.addEventListener("click", openTooltip);
    if (onClose) onClose(e);
  };

  if (!isClickToOpen) {
    var _tooltip$parentElemen5, _tooltip$parentElemen6;

    opener === null || opener === void 0 ? void 0 : opener.addEventListener("mouseenter", openTooltip);
    (_tooltip$parentElemen5 = tooltip.parentElement) === null || _tooltip$parentElemen5 === void 0 ? void 0 : _tooltip$parentElemen5.addEventListener("mouseleave", closeTooltip);
    (_tooltip$parentElemen6 = tooltip.parentElement) === null || _tooltip$parentElemen6 === void 0 ? void 0 : _tooltip$parentElemen6.addEventListener("focusin", openTooltip);
  } else {
    opener === null || opener === void 0 ? void 0 : opener.addEventListener("keydown", handleOpenerKeyDown);
  }

  opener === null || opener === void 0 ? void 0 : opener.addEventListener("click", openTooltip);
  opener === null || opener === void 0 ? void 0 : opener.addEventListener("blur", closeTooltipIfOutside);

  if (closeOnBlur) {
    var handleFocusOut = function handleFocusOut(event) {
      var focusedElement = event.relatedTarget;

      if (focusedElement && focusedElement !== opener && !tooltip.contains(focusedElement)) {
        closeTooltip();
      }
    };

    tooltip === null || tooltip === void 0 ? void 0 : tooltip.addEventListener("focusout", handleFocusOut);
  }

  if (tooltip.classList.contains("tds-tooltip--open")) {
    openTooltip();
  } else if (tooltip.classList.contains("tds-tooltip--closed")) {
    closeTooltip();
  }
};

var initTooltips = function initTooltips() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _props$parent = props.parent,
      parent = _props$parent === void 0 ? document : _props$parent;
  var tooltips = Array.from(parent.querySelectorAll(".tds-tooltip"));
  tooltips.forEach(function (component) {
    initTooltip(component, props);
  });
};

export { initTooltip, initTooltips, positionTooltip, positionTooltipOverlay, positionTooltipX, positionTooltipY, setTooltipOverlayX, setTooltipOverlayY };